module.exports = __webpack_public_path__ + "static/media/Tag.56531151.svg";